import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiCity\UpdateWikiCityController::__invoke
* @see app/Http/Controllers/WikiCity/UpdateWikiCityController.php
* @route '/api/city/{city}'
*/
const UpdateWikiCityController = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateWikiCityController.url(args, options),
    method: 'put',
})

UpdateWikiCityController.definition = {
    methods: ["put"],
    url: '/api/city/{city}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\WikiCity\UpdateWikiCityController::__invoke
* @see app/Http/Controllers/WikiCity/UpdateWikiCityController.php
* @route '/api/city/{city}'
*/
UpdateWikiCityController.url = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { city: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { city: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            city: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        city: typeof args.city === 'object'
        ? args.city.id
        : args.city,
    }

    return UpdateWikiCityController.definition.url
            .replace('{city}', parsedArgs.city.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiCity\UpdateWikiCityController::__invoke
* @see app/Http/Controllers/WikiCity/UpdateWikiCityController.php
* @route '/api/city/{city}'
*/
UpdateWikiCityController.put = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateWikiCityController.url(args, options),
    method: 'put',
})

export default UpdateWikiCityController